<svelte:options accessors/>
<script lang="ts">
    import {onMount} from "svelte";
    import FormPlaca from "./FormPlaca.svelte";
    import Dialog, {Actions, Content} from "@smui/dialog";
    import NauiButton from "../../naui/atoms/NauiButton.svelte";
    import NauiDialog from "../NauiDialog.svelte";
    import {v4 as uuidv4} from "uuid";
    import {ManagerVehicles} from "../../models/manager-vehicles";

    export let data = []
    export let selected = '';
    export let params: any;
    let validate: boolean = false;
    let manager: ManagerVehicles;

    let dialog: any = {
        open: false,
        message: '',
        vehicle: null
    }

    export let dialogCmpt;
    let indexToDelete = -1;


    let form

    interface IVehicle {
        cilindraje: string;
        codMarca: string;
        codModelo: string;
        codModeloTASA: string;
        descMarca: string;
        descModelo: string;
        descModeloTASA: string;
        placa: string;
        tipoCombustible: string;
        vin: string;
        year: any;
        selected?: boolean;
    }

    export function setLoading(params) {
        if (form) {
            form.loading = false;
            validate = false;
            dialogCmpt.$set({
                dialog: {
                    open: true,
                    message: `<p class="text-c">Vehículos actualizados</p>`
                }
            });

        }
    }

    onMount(() => {
        manager = ManagerVehicles.getInstance();
        manager.vehicles$.subscribe((vehicles) => {
            data = vehicles;
        });
    });

    function refresh() {
        data = [...data];
    }

    function showDialogDelVehicle(vehicle, index) {
        if (vehicle.placa) {
            dialog = {
                open: true,
                message: `¿Desea borrar el vehículo: <b>${vehicle.placa} - ${vehicle.descModeloTASA}</b>?`,
                vehicle
            };
        } else {
            const brand = vehicle.brands.length > 0 ? vehicle.brands[0] : null;
            const linea = (brand?.lineas || []).reverse().pop();
            dialog = {
                open: true,
                message: `¿Desea borrar el vehículo: <b>${brand?.name} - ${linea?.name}</b>?`,
                vehicle: {
                    ...vehicle,
                    index
                }
            };
        }
    }

    function deleteVehicle() {
        const {vehicle} = dialog;
        if (vehicle) {
            manager.deleteVehicle(vehicle);
            dialog = {
                open: false,
                message: ''
            }
            refresh();
        }
    }

</script>
<div>
    {#if (data?.length > 0 && !validate)}
        <div class="mb-2">
            <p>Selecciona tu Nissan y encuentra todo lo que necesitas</p>
        </div>
        {#if manager}
            {#each data as vehicle, i}
                <div class="border p-1 box-b sx-1 mb-1">
                    <div on:click={()=> manager.setSelected(vehicle)}>
                        {#if vehicle.selected}
                            <img height="24" width="24" src="/static/storefront/pix/material/check_circle.svg" alt="Uncheck vehicle">
                        {:else}
                            <img height="24" width="24" src="/static/storefront/pix/material/circle.svg" alt="Check vehicle">
                        {/if}
                    </div>
                    <div class="text-l">
                        <p>
                            {#if vehicle.placa}
                                {vehicle.placa}
                            {:else }
                                {vehicle.descModeloTASA}
                                - {vehicle.brands.length > 0 ? vehicle.brands[0].lineas[0].label : ''}
                            {/if}
                        </p>
                    </div>
                    <div class="del-vehicle" on:click={()=>showDialogDelVehicle(vehicle, i)}>
                        &times;
                    </div>
                </div>
            {/each}
        {/if}
        <div class="box-r mt-15">
            <div class="view-more" style="font-size: 15px"
                 on:click={()=>validate=true}>
                Validar nuevo vehículo
            </div>
        </div>
        <div class="box mt-2">
            <div class="btn accent min-w-200px text-c"
                 on:click={()=> location.href='/'}>
                CONTINUAR
            </div>
        </div>
    {:else}
        <div class="mb-2">
            <p>Ingresa tu número de placa o selecciona el modelo de tu vehículo y te mostraremos los productos
                apropiados para tu NISSAN</p>
        </div>
        <FormPlaca on:cancel={()=>validate=false}
                   on:validateVehicle
                   on:close={()=>validate=false}
                   {params}
                   bind:this={form}/>
    {/if}
</div>

<Dialog bind:open={dialog.open}
        scrimClickAction=""
        escapeKeyAction=""
        aria-describedby="mandatory-content">
    <Content id="mandatory-content">
        {@html dialog.message}
    </Content>
    <Actions>
        <div class="box sx-1 w-100">
            <NauiButton caption="ELIMINAR"
                        color="accent"
                        mode="solid"
                        on:click={()=>deleteVehicle()}/>
            <NauiButton caption="CANCELAR"
                        mode="solid"
                        on:click={() => {dialog.open = false;}}/>
        </div>
    </Actions>
</Dialog>

<NauiDialog bind:this={dialogCmpt}/>


<style>
    .del-vehicle {
        font-size: 2rem;
        cursor: pointer;
    }
</style>